import ErrorPage from "./error.page";
import { ErrorTemplate } from "./error.template";

export {
    ErrorTemplate as ErrorPageTemplate
}

export default ErrorPage
